<template>
  <div class="flex h-screen">
    <div id="sidebar" v-if="getProfile.role !== 'admin'" class="bg-primary-light fixed z-20">
      <Sidebar class="h-full overflow-hidden" @showSideMenu="showSideMenu" />
    </div>
    <div id="mainContainer" class="w-full overflow-x-hidden">
      <Header :changeHeader="changeHeader" />
      <div id="container-body" class="body-height overflow-y-auto" @scroll.passive="handleScroll">
        <slot></slot>
      </div>
    </div>
  </div>
  <!-- :class="[coursePages ? '' : 'pl-5 pr-4 pt-2.5 pb-2']" -->
</template>
<script>
  import Vue from 'vue';
  import $ from 'jquery';
  import { EventBus } from 'utils/event-bus';
  import { mapGetters } from 'vuex';
  import _ from 'lodash';
  export default Vue.extend({
    components: {
      Header: () => import('../../components/navbar/theHeader.vue'),
      Sidebar: () => import('../../components/menuSideBar/mainMenuSideBar.vue'),
      AreYouSureChangeTab: () =>
        import('../../features/onlineRoundtables/Modals/SureOnChangeTab.vue'),
    },
    data() {
      return {
        changeHeader: false,
        throttledSetScrollPosition: null,
      };
    },
    computed: {
      ...mapGetters(['getProfile', 'getCurrentRT']),
      sidebarGlobalState() {
        return this.$store.state.globalStateSidebar.isOpen;
      },
      coursePages() {
        return (
          this.$route.name === 'course.index' ||
          this.$route.name.includes('course.settings')
        );
      },
    },
    methods: {
      showSideMenu() {
        if (!this.sidebarGlobalState) {
          document.getElementById('sidebar').style.cssText = `width: 51px; transition: margin-left 0.3s`;
          document.getElementById('mainContainer').style.cssText = `margin-left: 51px;`;
        } else {
          document.getElementById('sidebar').style.cssText = `width: 270px; transition: 0.3s;`;
          document.getElementById('mainContainer').style.cssText = `margin-left: 270px; transition: margin-left 0.3s;`;
        }
      },
      handleScroll(e) {
        let currentScroll = e.target.scrollTop;
        this.throttledSetScrollPosition(currentScroll);

        const pagesNotScroll = [
          'course.settings.banners',
          'course.settings.general',
          'course.settings.integrations',
          'course.settings.participants',
        ];

        this.changeHeader = currentScroll > 45 && !pagesNotScroll.includes(this.$route.name);

        if (this.$route.name === 'roundtable.discussion') {
          $('.avatar').css({ position: 'static' });

          let posY = 0;
          let fix_pos = -1;
          let avatars = [];
          let cards = [];

          const feedCards = $('.feed-card');
          const avatarElements = $('.avatar');

          if (!feedCards.length || !avatarElements.length) return;

          feedCards.each(function (i, obj) {
            if (obj) {
              const height = $(obj).height();
              cards.push({ pos: i, height });
            }
          });

          avatarElements.each(function (i, obj) {
            if (obj && obj.classList.contains('submission-open')) {
              posY = obj.getBoundingClientRect().top + currentScroll - 65;
              avatars.push({ pos: i, height: posY });

              if (cards[i] && currentScroll > posY && cards[i].height > 300) {
                fix_pos = i;
              }
            }
          });

          const avatar_fix = avatars.find((a) => a.pos === fix_pos);
          if (avatar_fix && currentScroll > avatar_fix.height) {
            const avatarEl = avatarElements.eq(avatar_fix.pos);
            if (avatarEl.length) {
              avatarEl.css({
                position: 'relative',
                top: currentScroll - avatar_fix.height + 'px',
              });
            }
          }
        }
      }
    },
    mounted() {
      if (this.$route.params.courseID === this.$store.state.course_sample_id && this.getProfile.is_sample !== true) {
        this.$el.addEventListener('click', (e) => {
          if (e.target.closest('.sample')) {
            e.stopPropagation();
            EventBus.$emit('openToast', true);
          }
        }, true);
      }

      this.throttledSetScrollPosition = _.throttle((scrollPosition) => {
        this.$store.commit('setScrollPosition', scrollPosition);
      }, 2000);

      if (this.sidebarGlobalState === true) {
        document.getElementById('sidebar').style.width = '270px';
        document.getElementById('mainContainer').style.marginLeft = '270px';
      } else {
        document.getElementById('sidebar').style.width = '48px';
        document.getElementById('mainContainer').style.marginLeft = '48px';
      }
    },
    beforeDestroy() {
      this.$el.removeEventListener(
        'click',
        (e) => {
          if (e.target.closest('.sample')) {
            e.stopPropagation();
          }
        },
        true
      );
    },
  });
</script>
<style scoped>
  .body-height {
    height: calc(100% - 44px)
  }
</style>



// WEBPACK FOOTER //
// default.vue?04565d2a